/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Flex", {
  enumerable: true,
  get: function get() {
    return _Flex.default;
  }
});
Object.defineProperty(exports, "Item", {
  enumerable: true,
  get: function get() {
    return _Item.default;
  }
});
exports.default = void 0;
var _Flex = _interopRequireDefault(require("./Flex"));
var _Item = _interopRequireDefault(require("./Item"));
var _default = {
  Flex: _Flex.default,
  Item: _Item.default
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Flex/src/index.js
// module id = 683
// module chunks = 0